import $ from 'jquery'
import http from '@/utils/http';
import lazy from '@/utils/lazy'
import {
    INTERFACE
} from '@/utils/INTERFACE'
import _ from 'lodash';
import {
    getPrice,
    getSpuPrice
} from '@/api/price'
import {
    getSystem
} from '@/utils/site'
const ProductModule = ['Commodity', 'Promotion', 'ShopCommodity', 'ShopCommodity2', 'Spike', 'PreSale'];
const PromoModule = ['HotImage', 'Carousel', 'ADPicture'];
const PointSelect = '[href],[ref],a[module-function],.J_send-log';
const system = getSystem();
const max_sku = 100;
let isShop = $('#J_venderId').val().length > 0;
export async function getSkuInfo(skus) {
    let groupSkus = [];
    if (system !== 'th' || skus.length === 0) {
        return;
    }
    if (skus.length > max_sku) {
        groupSkus = _.chunk(skus, max_sku);
    } else {
        groupSkus = [skus];
    }
    let res = await Promise.all(groupSkus.map(item => http.jsonp.get(INTERFACE().skuInfo, {
        skuStr: _.uniq(item).join(',')
    })));
    let skuInfo = {};
    res.filter(i => i.result).forEach(i => skuInfo = { ...skuInfo,
        ...i.skuInfo
    });
    return skuInfo;
}
export async function impression(module) {
    if (system != 'th') {
        return;
    }
    let $module = $(module);
    let moduleName = $module.attr('module-name');
    let moduleAlias = $module.attr('module-alias') || $module.attr('module-name');
    let instanceid = $module.attr('instanceid');
    let isProduct = ProductModule.indexOf(moduleName) >= 0;
    let isPromo = PromoModule.indexOf(moduleName) >= 0;
    let impressionList = [];
    let $points, shopName;
    if (!isProduct && !isPromo) {
        return;
    }
    if (isShop) {
        shopName = $("#J_shopName").length && $("#J_shopName").val();
    }
    if (isProduct) {
        $points = $module.find('[skuid]');
    }
    if (isPromo) {
        $points = $module.find(PointSelect);
    }
    if (!$points || $points.length === 0) {
        return;
    }
    $points.each(function(i, point) {
        let position = i + 1;
        if (isProduct) {
            let $point = $(point);
            let id = $point.attr('skuid');
            impressionList.push({
                id,
                position,
                list: isShop ? `shop-${shopName}-${moduleAlias}` : `channel-${moduleAlias}`
            })
        }
        if (isPromo) {
            impressionList.push({
                position,
                id: instanceid,
                name: moduleAlias,
                creative: ''
            })
        }
    });
    if (isProduct) {
        let ids = impressionList.map(i => i.id);
        let prices = await getPrice(ids);
        let skuInfos = await getSkuInfo(ids)
        dataLayer.push({
            event: 'productImpression',
            ecommerce: {
                currencyCode: 'THB',
                Impressions: impressionList.map(i => ({ ...i,
                    price: prices[i.id].discountPrice,
                    ...skuInfos[i.id]
                }))
            }
        })
    }
    if (isPromo) {
        dataLayer.push({
            event: 'promotionImpression',
            ecommerce: {
                promoView: {
                    promotions: impressionList
                }
            }
        })
    }
}
$(function() {
    if (system != 'th') {
        return;
    }
    $('body').on('click', PointSelect, function(e) {
        let currentTarget = e.currentTarget;
        let $module = $(currentTarget).closest('div[instanceid]');
        let moduleName = $module.attr('module-name');
        let moduleAlias = $module.attr('module-alias') || $module.attr('module-name');
        let isProduct = ProductModule.indexOf(moduleName) >= 0;
        let isPromo = PromoModule.indexOf(moduleName) >= 0;
        let instanceid = $module.attr('instanceid');
        let shopName;
        if (!$module || $module.length === 0) {
            return
        }
        if (isShop) {
            shopName = $("#J_shopName").length ? $("#J_shopName").val() : '';
        }
        $module.find(PointSelect).each(async function(index, item) {
            if (item === currentTarget) {
                let position = index + 1;
                if (isProduct) {
                    let $point = $(currentTarget).closest('[skuid]');
                    let id = $point.attr('skuid');
                    let price = await await getPrice([id]);
                    let skuInfo = await await getSkuInfo([id]);
                    dataLayer.push({
                        event: 'productClick',
                        ecommerce: {
                            click: {
                                actionField: {
                                    list: isShop ? `shop-${shopName}-${moduleAlias}` : `channel-${moduleAlias}`,
                                    action: 'click'
                                },
                                products: [{
                                    id,
                                    position,
                                    price: price[id].discountPrice,
                                    ...skuInfo[id]
                                }]
                            }
                        }
                    });
                }
                if (isPromo) {
                    dataLayer.push({
                        event: 'promotionClick',
                        ecommerce: {
                            promoClick: {
                                promotions: [{
                                    id: instanceid,
                                    name: moduleAlias,
                                    creative: '',
                                    position
                                }]
                            }
                        }
                    })
                }
                return;
            }
        })
    })
})